// NPM Imports
import React from "react";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "../../../revvComponents";

// Actions Imports
import { EditorActions } from "../../../actions";
import { updateComponentMeta } from "../../../actions/DocumentActions/index";
// Services Imports

// Internal Imports
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { DOCUMENT_MODE } = DOCUMENTS;
const { nukeActiveEditor } = EditorActions;

// Declarations
const BLOCKS_NOT_FOR_CLONE = {
  Signature: true,
  SignatureName: true,
  SignatureDate: true,
  SignatureInitials: true,
  PageNumber: true,
  SignText: true,
  SignCheckbox: true,
};

export default function ComponentCloneBtn({
  clauseOptionsDetails,
  cloneSection,
  mode,
  sectionType,
}) {
  // mapDispatchToProps
  const dispatch = useDispatch();

  const isDisabled =
    !!clauseOptionsDetails &&
    (mode === DOCUMENT_MODE.TEMPLATE ||
      clauseOptionsDetails.type === "TABLE_API");

  const _handleClone = () => {
    if (!isDisabled) {
      dispatch(updateComponentMeta({}));
      dispatch(nukeActiveEditor(true, true));
      cloneSection();
    }
  };

  if (BLOCKS_NOT_FOR_CLONE[sectionType]) return null;

  return (
    <Tooltip
      placement="top"
      overlay={
        isDisabled
          ? "Blocks converted to placeholder fields cannot be cloned"
          : "Clone this block"
      }
      align={{ offset: [0, 3] }}>
      <span
        data-test="documentitems-clone-the-content-btn"
        className={`btn-icon ${isDisabled ? "disabled-lock" : ""}`}
        id="clone-the-content-btn"
        disabled={isDisabled}
        onMouseDown={_handleClone}
        role="button"
        tabIndex={0}>
        <FontAwesomeIcon icon={["far", "clone"]} />
      </span>
    </Tooltip>
  );
}
